import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HTTP_INTERCEPTORS, HttpResponse } from '@angular/common/http';
import { Observable, finalize, tap } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';
import { MessageService } from 'primeng/api';
import { SharedService } from '../shared/shared.service';
import { Router } from '@angular/router';

// Add any external URLs that should skip auth headers
const SKIP_AUTH_URLS = [
  'dashboards.apollosupplychain.com/api/queries',
  '/redash-proxy'  
];

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private messageService: MessageService,
    private sharedService: SharedService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.sharedService.updateLoader(true);

    // ✅ Skip auth headers for external/public APIs (e.g. Redash)
    const isExternalUrl = SKIP_AUTH_URLS.some(url => request.url.includes(url));

    if (isExternalUrl) {
      // Pass through completely unmodified — no auth, no withCredentials
      return next.handle(request).pipe(
        finalize(() => this.sharedService.updateLoader(false))
      );
    }

    const authToken = this.auth.getAuthToken() || localStorage.getItem('access_token');

    let headers = request.headers
      .set('DEVICE-TYPE', 'Web')
      .set('VER', '1');

    if (authToken) {
      headers = headers.set('Authorization', `Bearer ${authToken}`);
    }

    const requestToHandle = request.clone({
      headers,
      withCredentials: true,
    });

    return next.handle(requestToHandle).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // Handle response if needed
          }
        },
        (error: any) => {
          this.sharedService.updateLoader(false);

          const suppressErrorMessage = requestToHandle.headers.get('Suppress-Error-Message') === 'true';

          if (error.status === 401) {
            this.auth.logOut();
          } else if (error.status === 404) {
            if (!suppressErrorMessage) {
              // this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error ? error.error.responseMessage : 'Something went wrong' });
            }
          } else {
            if (!suppressErrorMessage) {
              if (this.router.url.includes('transport-services/dispatch-details')) { return; }
              console.error('Error:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.error ? error.error.responseMessage : 'Something went wrong',
              });
            }
          }
        }
      ),
      finalize(() => {
        this.sharedService.updateLoader(false);
      })
    );
  }
}

export let tokenProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: TokenInterceptor,
  multi: true,
};